import React ,{ useState, useEffect , useFocusEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

function HeaderPrelogin(props ) { 
    const menuVal = useSelector(state => state.bar_controller.value)
    
    const [value,setValue] = useState();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const Logout = () =>{
        navigate("/login")
    }
    const goPreviousPage = () => {
        window.location.reload(false)
        //setValue({});
    }
    

  
    return (
        <header className="header">
            <div className="header_portal_name">
                <button  className="header_portal_menu selfcare" onClick={goPreviousPage}>
                <svg width="25" height="25" id="icon-menu" viewBox="0 0 24 24">
                    <path fill="#fafafa" d="M21 11.016v1.969h-14.156l3.563 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.563 3.609h14.156z"></path>
                </svg>
                </button>
                <h3 className="header_portal_name_heading">{props.journey}</h3>
            </div>
            <div className="header_logout">
                <div className="header_logout_text">
                    Logged In As:
                    <span>EKIMANI</span>
                </div>
                <button className="header_logout_btn" onClick={Logout}>
                <svg id="icon-logout" width="25" height="25" viewBox="0 0 24 24">
                    <path d="M3.984 5.016v13.969h8.016v2.016h-8.016q-0.797 0-1.383-0.609t-0.586-1.406v-13.969q0-0.797 0.586-1.406t1.383-0.609h8.016v2.016h-8.016zM17.016 6.984l4.969 5.016-4.969 5.016-1.406-1.453 2.578-2.578h-10.172v-1.969h10.172l-2.578-2.625z"></path>
                </svg>
                    Logout
                </button>
            </div>
        </header>
    );
  }

  export default HeaderPrelogin;
